import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
]
